import { OrderFormData, OrderType, TradeType } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useNormalOrderSchema } from '../../schemas/orderSchemas';
import { ValidatedOrderWithPrice } from './useNormalOrderView';

export const useOrderExchange = () => {
  const { getNormalOrderSchema } = useNormalOrderSchema();
  const getIsValidOrder = useCallback(
    (order?: OrderFormData): ValidatedOrderWithPrice | false => {
      if (
        order &&
        order.price &&
        getNormalOrderSchema(order).isValidSync(order, { abortEarly: false }) &&
        order.tradeType === TradeType.Buy &&
        (order.orderType === OrderType.Limit ||
          order?.orderType === OrderType.StopLimit ||
          order?.orderType === OrderType.Oco)
      ) {
        return order as ValidatedOrderWithPrice;
      }

      return false;
    },
    [getNormalOrderSchema],
  );

  return {
    getIsValidOrder,
  };
};
